import axios from "../general/HttpClient";

import { isArray, clone } from "lodash";

export class Application {
    applicationType: number;
    url: string;
    name: string;
    logo: string;
    design: {
        title: string;
        subTitle: string;
        text: string;
        image: string;
        primaryColor: string;
        secondaryColor: string;
    };
    actions: Array<ApplicationAction>;
}

export class ApplicationAction {
    text: string;
    url: string;
    icon: string;
}

let fetching = false;
//@ts-ignore
let promise = null as Promise<Array<Application>>;

export function LoadMyApps(): Promise<Array<Application>> {
    if (fetching) {
        return promise;
    } else {
        fetching = true;
        promise = axios.get("/api/Applications/GetMyApplications").then((response) => {
            let result = isArray(response.data) ? response.data : [];
            fetching = false;
            return result;
        });

        return promise;
    }
}
